import "../CustomMenu.css";
import { Link } from 'react-router-dom'

export default function CustomBNBMenu() {
  return (
    <div className="RealCustomMenu">
      <div className="CustomMenuHeader">SELECT</div>
      <div className="CustomMenu">
        <Link className="CustomMenu" to='/kustombnb'>KUSTOMIZE</Link>
      </div>
      <div className="CustomMenu">
        <Link className="CustomMenu" to='/kustombnbbackground'>CHANGE BACKGROUND COLOR</Link>
      </div>
      <div className="CustomMenu">
        <Link className="CustomMenu" to='/kustombnbfinality'>FINALITY</Link>
      </div>
      <div className="CustomMenu">
        <Link className="CustomMenu" to='/kustomMenu'>BACK</Link>
      </div>
    </div>
  );
}
